// Calculator/index.tsx
import { RefreshOutlineIcon } from 'assets/svgs';
import { Button, DescriptionBar, Input, Label, SelectBox, Text } from 'components';
import { isNaN } from 'lodash-es';
import { useEffect, useState } from 'react';
import { currencyOption, planTypeOption } from './utils';
import { useNavigate } from 'react-router-dom';
import 'styles/mobile.css';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Calculator = () => {
  const { t } = useTranslation();
  const nav = useNavigate();

  const [planType, setPlanType] = useState<number>(planTypeOption[0]?.value || 1);
  const [currency, setCurrency] = useState<number>(currencyOption[0]?.value || 1);
  const [period, setPeriod] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [pricePerMin, setPricePerMin] = useState<number>(0);
  const [pricePerMinText, setPricePerMinText] = useState<string>('');

  function onClickReset() {
    setPlanType(planTypeOption[0]?.value || 1);
    setCurrency(currencyOption[0]?.value || 1);
    setTotal(0);
    setPeriod(1);
  }

  function onMoveContact() {
    nav('/contact-us');
  }

  useEffect(() => {
    if (isNaN(period) || period <= 0) {
      setTotal(0);
      return;
    }
    const calculatedTotal = pricePerMin * period;
    const currencyLabel = currencyOption.find((item) => item.value === currency)?.label;
    if (currencyLabel === 'calculator.currency.1' || currencyLabel === 'calculator.currency.2') {
      // calculatedTotal *= 1.1;
    }
    setTotal(calculatedTotal);
  }, [pricePerMin, period, currency]);

  useEffect(() => {
    const currencyString = currencyOption.find((option) => option.value === currency)?.label;
    const planTypeString = planTypeOption.find((option) => option.value === planType)?.label;
    if (!currencyString || !planTypeString) {
      setPricePerMin(0);
      setPricePerMinText('');
      return;
    }
    if (planTypeString === 'calculator.plan.pass') {
      // currency 값으로 직접 판단: 1 = KRW, 2 = USD
      setPricePerMin(currency === 1 ? 3000 : 2.5);
      setPricePerMinText(currency === 1 ? 'KRW 3,000' : 'USD 2.50');
    } else {
      setPricePerMin(0);
      setPricePerMinText('');
    }
  }, [currency, planType]);

  const formattedTotal =
    currency === 1 // KRW
      ? total.toLocaleString(undefined, { maximumFractionDigits: 0 })
      : total.toLocaleString(undefined, { minimumFractionDigits: 2 });

  return (
    <>
      <Helmet>
        <title>{t('calculator.pageTitle')} | IOPS SPACE</title>
        <meta name="description" content={t('calculator.pageDescription')} />
      </Helmet>
      <div className="h-full max-w-[800px]">
        <DescriptionBar
          className="mb-2 md:pt-1"
          title={t('calculator.pageTitle')}
          description={t('calculator.pageDescription')}
        />
        <div className="flex w-full flex-1 flex-col gap-4 px-4 py-6 padding-md">
          <SelectBox
            className="max-w-none"
            bgColor="layer2"
            label={t('calculator.label.currency')}
            list={currencyOption.map(opt => ({ ...opt, label: t(opt.label) }))}
            value={currency}
            setValue={setCurrency}
          />
          <SelectBox
            className="max-w-none"
            bgColor="layer2"
            label={t('calculator.label.planType')}
            list={planTypeOption.map(opt => ({ ...opt, label: t(opt.label) }))}
            value={planType}
            setValue={setPlanType}
          />
          <Input
            type="text"
            isDisabled
            label={t('calculator.label.pricePerMin')}
            value={pricePerMinText}
          />
          <Input
            type="number"
            label={t('calculator.label.usagePeriod')}
            value={period}
            setValue={setPeriod}
          />
          <div className="flex w-full items-center justify-between display-md">
            <div className="flex flex-row items-center gap-2">
              <Button htmlType="submit" type="blue" text={t('calculator.button.moreInfo')} size="medium" onClick={onMoveContact} aria-label="Go to Contact Us" />
              <Button
                htmlType="button"
                type="tertiary"
                text={t('calculator.button.reset')}
                icon={<RefreshOutlineIcon />}
                size="medium"
                onClick={onClickReset}
                aria-label="calculate reset"
              />
            </div>
            <div className="flex items-center gap-2 pt-md">
              <Label
                className="mb-0"
                label={t('calculator.label.totalEstimatedCost')}
                color="tertiary"
              />
              <Text size="heading3" weight="medium" color="black">
                {t(currencyOption.find((item) => item.value === currency)?.label || 'calculator.currency.1')}
              </Text>
              <Text size="heading3" weight="medium" color="black">
                {formattedTotal}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calculator;
